export default __webpack_public_path__ + "static/media/grafema_ummi_15.04398685.jpg";